import { spotlight } from '@/mocks/home';

export default function SpotlightSection() {
  return (
    <section id="spotlight" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-8xl px-4 md:px-8">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-6">
            <div className="relative h-[280px] w-full overflow-hidden rounded-lg md:h-[420px]">
              <img
                src={spotlight.image}
                alt={`${spotlight.title}专题配图`}
                className="h-full w-full object-cover object-top"
              />
              <span className="absolute bottom-4 left-4 inline-flex items-center gap-2 rounded-md bg-foreground-950/78 px-3 py-1.5 text-xs text-background-50">
                <i className="ri-article-line text-accent-400"></i>
                {spotlight.kicker}
              </span>
            </div>
          </div>

          <div className="lg:col-span-6">
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.2em] text-accent-700">
              <i className="ri-focus-3-line"></i>
              DEEP DIVE
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              {spotlight.title}
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              {spotlight.summary}
            </p>

            <ul className="mt-6 space-y-3">
              {spotlight.points.map((point) => (
                <li key={point} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-800">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  <span className="text-sm leading-relaxed text-foreground-700 md:text-base">
                    {point}
                  </span>
                </li>
              ))}
            </ul>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#contact"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
              >
                <i className="ri-book-open-line"></i>
                阅读完整专题
              </a>
              <span className="text-xs leading-relaxed text-foreground-500 md:text-sm">
                {spotlight.footnote}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}